import RequestInstance from '../request.instance';
import { IResponse } from '../request.interface';
import { IKlineReq, ILineChartReq } from './kline.request.interface';
import { IKline } from './kline.response.interface';

class KLineApiService {
  private readonly requestInstance: RequestInstance;
  constructor() {
    this.requestInstance = new RequestInstance();
  }

  // 获取K线数据
  async getKlineApi(params: IKlineReq): Promise<IResponse<IKline[]>> {
    return await this.requestInstance.businessRequest({
      url: `/kline`,
      method: 'GET',
      params,
    });
  }

  async getTokenLineChartApi(params: ILineChartReq): Promise<IResponse<IKline[]>> {
    return await this.requestInstance.businessRequest({
      url: `/kline/token`,
      method: 'GET',
      params,
    });
  }
}

export default new KLineApiService();
